import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BcmWidget } from '@bcmApiServices/bcm-widget-settings-api.service';

@Injectable({providedIn: 'root'})
export class WidgetWrapperSharedService {

    protected _newWidgetSelectedToAdd = new Subject<BcmWidget>();

    public get newWidgetSelectedToAdd(): Observable<BcmWidget> {
        return this._newWidgetSelectedToAdd.asObservable();
    }

    protected _editModeActive = new BehaviorSubject<boolean>(false);

    public get editModeActive(): Observable<boolean> {
        return this._editModeActive.asObservable();
    }

    // --

    public addWidgetToCurrentDashboard(widget: BcmWidget): void {
        return this._newWidgetSelectedToAdd.next(widget);
    }

    public switchEditMode(value: boolean): void {
        return this._editModeActive.next(value);
    }
}
